(function () {
  if (window.__rodSpecsTableInit) return;
  window.__rodSpecsTableInit = true;

  function updateCartIcon(response) {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && response.sections?.['cart-icon-bubble']) {
      cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
    }
  }

  async function handleRowSubmit(form) {
    const submitBtn = form.querySelector('button[type="submit"]');
    const feedback = form.querySelector('.row-atc-feedback');
    const cartDrawer = document.querySelector('cart-drawer');
    const originalText = submitBtn ? submitBtn.textContent.trim() : 'Add to cart';

    if (!submitBtn || submitBtn.getAttribute('aria-disabled') === 'true') return;

    try {
      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      if (feedback) feedback.textContent = '';

      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
      submitBtn.classList.add('is-loading');

      const formData = new FormData(form);

      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();

      let error = typeof data.description === 'string' ? data.description : data.message;
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map((item) => item[1].join(', '));
      }

      if (data.status) {
        if (feedback) feedback.textContent = Array.isArray(error) ? error.join(', ') : error;
      }

      if (!response.ok) throw new Error(response.status);

      updateCartIcon(data);

      if (cartDrawer) {
        setTimeout(() => {
          cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
        }, 700);
      }

      form.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { variantId: data.variant_id }
      }));

      submitBtn.textContent = 'Added';
      if (feedback) feedback.textContent = 'Added to cart';
    } catch (error) {
      console.log(error); // eslint-disable-line

      if (feedback) feedback.textContent = 'Unable to add item to cart';

      form.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: feedback ? feedback.textContent : 'Unable to add item to cart'
        }
      }));

      if (cartDrawer) cartDrawer.refresh(true);
      submitBtn.textContent = originalText;
    } finally {
      submitBtn.classList.add('is-success');
      submitBtn.removeAttribute('aria-disabled');

      setTimeout(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.remove('is-success');
        if (feedback) feedback.textContent = '';
      }, 1400);
    }
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.row-atc--ajax');
    if (!form) return;

    event.preventDefault();
    handleRowSubmit(form);
  });
})();